@if (failure.kind(); as failureKind) {
  <lib-error-state [kind]="failureKind" [retrying]="failure.isRetrying()" (retry)="failure.retry()"></lib-error-state>
} @else if (anyIsLoading() || staticLoad()) {
  @defer (on timer(500ms)) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
} @else {
  <ng-content></ng-content>
}
